import { formatDistanceToNow, format, isToday, isYesterday } from "date-fns";

interface RelativeTimeProps {
  date: string | Date;
  className?: string;
}

export function RelativeTime({ date, className }: RelativeTimeProps) {
  const d = typeof date === "string" ? new Date(date) : date;

  const relative = formatDistanceToNow(d, { addSuffix: true });
  const absolute = isToday(d)
    ? `Today at ${format(d, "h:mm a")}`
    : isYesterday(d)
      ? `Yesterday at ${format(d, "h:mm a")}`
      : format(d, "MMM d, yyyy 'at' h:mm a");

  return (
    <time
      dateTime={d.toISOString()}
      title={absolute}
      className={className}
      style={{ cursor: "default" }}
    >
      {relative}
    </time>
  );
}
